// extracted by mini-css-extract-plugin
export default {"container":"Dropdown_container__djQrU"};